import api from "../core/axios";

export const authApi = {
    login: (data) => api.post("/login", data),
    register: (userData) => api.post("/register", userData),
    logout: () => api.post("/auth/logout"),
    logoutAll: () => api.post("/auth/logout-all"),
    refresh: () => api.post("/auth/refresh"),
    me: () => api.get("/auth/me"),
    changePassword: (data) => api.post("/auth/change-password", data),
}